export default __webpack_public_path__ + "static/media/vip-banner-one-desktop.e664e3ae.png";